module.exports = "/assets/d05c2c8298bda308d66e88fb297be9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/trip-item-ferry/assets/ferry.png
// module id = 3454
// module chunks = 0